import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface IBackButton {
  url?: string;
  id: string;
  sx?: React.CSSProperties;
}

const WSBackButton: React.FC<IBackButton> = ({ url: initialUrl, id, sx }) => {
  const navigate = useNavigate();
  const [url] = useState(initialUrl);

  const handleBack = () => {
    if (url) navigate(url);
    else navigate(-1);
  };

  return (
    <Box
      onClick={handleBack}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        border: "1.5px solid #15B788", // Figma green border
        background: "#FFFFFF",
        padding: "6px 14px",
        borderRadius: "40px", // full oval shape
        width: "fit-content",
        cursor: "pointer",
        "&:hover": {
          background: "#F6FFFB",
        },
        ...sx
      }}
    >
      <ArrowBackIcon
        sx={{
          color: "#15B788",
          fontSize: 20
        }}
      />

      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
          color: "#15B788", // green text same as figma
          fontSize: "16px",
        }}
      >
      Back
      </Typography>
    </Box>
  );
};

export default WSBackButton;
